module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACgSURBVDhPYxg4kJiYGJKQkJATHx+/C4jT0PAukBxIDVQ5AgAlLwHxVKCCO0C6AxlDxaYC8SWocgQACQIVzAfimTjwfHwa/YHOccGGQXI4NaalpfFDuXAQBwF6IDmCGmNjYw1BNNCWJCA+k5ycLESMRkag4m1AvBGmCSRPlI1ANgcQ98E0gQBRGrEBvBqBTiMrOiywRQMyBqmBKicXMDAAAAx9lWZe9IQuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/calendar_icon.png
// module id = 21
// module chunks = 0